import { Avatar, Paper, Stack, Typography } from '@mui/material';
import { Add } from 'Images';

interface IAddPaperCard {
  label: string;
  secondaryLabel?: string;
  add: () => void;
}
export const AddPaperCard = (props: IAddPaperCard) => {
  return (
    <Paper
      variant='outlined'
      sx={{
        backgroundColor: `linear-gradient(358.5deg, #F8F8F8 -32.79%, rgba(255, 255, 255, 0.765625) 79.18%, rgba(255, 255, 255, 0) 444.94%)`,
        border: '1px dashed #0000003D',
        display: 'flex',
        flexFlow: 'column',
        justifyContent: 'left',
        alignItems: 'center',
        minHeight: '82px',
        cursor: 'pointer',
        padding: '26px 32px',
        maxWidth: '780px',
        borderRadius: (theme) => `${theme.shape.borderRadius}px`,
      }}
      onClick={() => props.add()}
      onKeyPress={(e) => {
        if (e.key === 'Enter') {
          props.add();
        }
      }}
      tabIndex={0}
      role={'button'}
    >
      <Stack direction='row' alignItems='center'>
        <Avatar
          src={Add}
          alt={props.label}
          sx={{ width: '30px', height: '30px' }}
        />
        <Typography
          sx={{
            fontWeight: 'bold',
          }}
        >
          {props.label}
        </Typography>
      </Stack>

      {Boolean(props.secondaryLabel) && (
        <Typography
          sx={{
            pl: '30px',
          }}
        >
          {props.secondaryLabel}
        </Typography>
      )}
    </Paper>
  );
};
